import * as React from 'react';
import { cn } from '@/core/lib/utils';

interface DateTimePickerProps {
  value?: Date | string;
  onChange?: (date: Date | undefined) => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  min?: string;
  max?: string;
}

export function DateTimePicker({
  value,
  onChange,
  disabled = false,
  className,
  placeholder,
  min,
  max,
}: DateTimePickerProps) {
  const inputValue = React.useMemo(() => {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(date.getTime())) return '';
    return date.toISOString().slice(0, 16);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (!newValue) {
      onChange?.(undefined);
      return;
    }
    onChange?.(new Date(newValue));
  };

  return (
    <input
      type="datetime-local"
      value={inputValue}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      min={min}
      max={max}
      className={cn(
        'flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm',
        'focus:outline-none focus:ring-2 focus:ring-sage-500 focus:border-transparent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
    />
  );
}

export default DateTimePicker;
